import { useMemo, useState } from 'react';
import ExpenseListing from './expenseListing';
import { EntriesSections, EntryEntity } from '../../../constants/entries';
import { useTranslation } from 'react-i18next';
import EntriesTransactionListing from './entries-transaction-listing';
import CustomTabs from '../../customTabs/customTabs';
import { IMatter } from '../../../interface';

const EntriesView = ({
  entity,
  invoicingPeriod,
  matter,
  isBillableMatter,
}: {
  entity: EntryEntity;
  matter?: IMatter;
  invoicingPeriod?: (string | null)[];
  isBillableMatter?: boolean;
}) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<string>();
  const items = useMemo(
    () => [
      {
        key: EntriesSections.transactions,
        label: t('common:tab.transactions'),
        children: (
          <EntriesTransactionListing
            entity={entity}
            invoicingPeriod={invoicingPeriod}
            matter={matter}
            isBillableMatter={isBillableMatter}
          />
        ),
      },
      {
        key: EntriesSections.expenses,
        label: t('common:tab.expenses'),
        children: (
          <ExpenseListing entity={entity} matter={matter} isBillableMatter={isBillableMatter} />
        ),
      },
    ],
    [],
  );

  return <CustomTabs activeKey={selectedTab} onChange={setSelectedTab} items={items} />;
};

export default EntriesView;
